import { DatasetFilter, FilterOption } from "@/types/dataset";

import SavedFilterItem from "./SavedFilterItem";

type SavedFiltersListProps = {
  filters: DatasetFilter[];
  filterOptions: FilterOption[];
  onEdit?: (filter: DatasetFilter) => void;
  onDelete?: (filter: DatasetFilter) => void;
};

const SavedFiltersList = ({
  filterOptions,
  filters,
  onEdit,
  onDelete
}: SavedFiltersListProps) => {
  return (
    <div className="space-y-3 font-sans" data-testid="saved-filters-list">
      {filters.map((filter) => (
        <SavedFilterItem
          key={`${filter.filterId}_${filter.attributeCode ?? ""}`}
          filter={filter}
          filterOptions={filterOptions}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default SavedFiltersList;
